import { TimeFormats } from 'app/constants/TimeFormat';
import { IHoliday } from 'app/models/holiday';
import { IShuttle, IShuttleTime } from 'app/models/shuttle';
import { ByLineForm } from './ByLine.model';

export const supportOverHour = (shuttles: IShuttle[]): IShuttle[] => {
  return shuttles.map((shuttle: IShuttle) => {
    const times = shuttle.times.map((time: IShuttleTime) => {
      if (time.overHours) {
        const weekDays = mooveWeek(time.weekDays, 'prev');

        return { ...time, weekDays };
      }

      return time;
    });

    return { ...shuttle, times };
  });
};

const mooveWeek = (weekDays: number[], step: 'next' | 'prev'): number[] => {
  return weekDays.map((dayOfWeek: number) => {
    if (dayOfWeek >= 0 && dayOfWeek <= 6) {
      if (step === 'prev') {
        return dayOfWeek - 1 < 0 ? dayOfWeek + 6 : dayOfWeek - 1;
      }

      return dayOfWeek + 1 > 6 ? dayOfWeek - 6 : dayOfWeek + 1;
    }

    return dayOfWeek;
  });
};

export const findShuttle = (shuttles: IShuttle[], holidays: IHoliday[], form: ByLineForm): IShuttle | null => {
  const holidayCode =
    holidays.find((holiday: IHoliday) => holiday.date === form.date?.format(TimeFormats.ServerFormatDate))?.code || -1;

  return (
    shuttles.find((shuttle: IShuttle) => {
      if(!shuttle.times?.length){
        return;
      }

      const shuttleWeekdays = shuttle.times[0].weekDays;

      if (holidayCode !== -1) {
        return (
          (shuttle.area === form.area || (!shuttle.area && !form.area)) &&
          shuttle.line === form.line &&
          shuttle.direction === form.direction &&
          shuttleWeekdays.includes(holidayCode)
        );
      }

      return (
        (shuttle.area === form.area || (!shuttle.area && !form.area)) &&
        shuttle.line === form.line &&
        shuttle.direction === form.direction &&
        form.date &&
        shuttleWeekdays.includes(form.date?.weekday())
      );
    }) ?? null
  );
};
